import React from 'react'
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons'
import type { BulkUploadResultDto } from '../../api/dto/client-billing-profile.dto'
import { sureco } from '../shared/finance.styles'
import {
  ModalScrollBody,
  UploadErrorBanner,
  UploadErrorBannerHeader,
  UploadErrorItem,
  UploadErrorList,
  UploadResultStat,
  UploadResultSummary,
  UploadSuccessNote,
} from './ClientBillingProfileManagement.styles'

/** What the upload did, and the rows the server turned away. */
const BulkUploadResultsStep = ({ result }: { result: BulkUploadResultDto }) => (
  <ModalScrollBody>
    <UploadResultSummary>
      <UploadResultStat $color={sureco.successText}>
        <span>{result.created}</span>
        <span>Created</span>
      </UploadResultStat>
      <UploadResultStat $color={sureco.teal}>
        <span>{result.updated}</span>
        <span>Updated</span>
      </UploadResultStat>
      <UploadResultStat $color={sureco.fg3}>
        <span>{result.skipped}</span>
        <span>Skipped</span>
      </UploadResultStat>
      <UploadResultStat $color={sureco.danger}>
        <span>{result.errors.length}</span>
        <span>Errors</span>
      </UploadResultStat>
    </UploadResultSummary>

    {result.errors.length === 0 ? (
      <UploadSuccessNote>
        <CheckCircleOutlined style={{ fontSize: 28, marginBottom: 8 }} />
        <div>All rows processed successfully</div>
      </UploadSuccessNote>
    ) : (
      <UploadErrorBanner>
        <WarningOutlined style={{ marginTop: 3, flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <UploadErrorBannerHeader>
            {result.errors.length} {result.errors.length === 1 ? 'row' : 'rows'}{' '}
            had errors
          </UploadErrorBannerHeader>
          <UploadErrorList>
            {result.errors.map((error) => (
              <UploadErrorItem key={error.row}>
                <span>Row {error.row}</span>
                <span>{error.message}</span>
              </UploadErrorItem>
            ))}
          </UploadErrorList>
        </div>
      </UploadErrorBanner>
    )}
  </ModalScrollBody>
)

export { BulkUploadResultsStep }
